import { ChevronLeft, ChevronRight } from 'lucide-react';

export function Paginador({
  pagina,
  porPagina,
  total,
  quePagina,
  alCambiar,
}: {
  pagina: number;
  porPagina: number;
  total: number;

  quePagina: string;
  alCambiar: (pagina: number) => void;
}) {
  const totalPaginas = Math.max(1, Math.ceil(total / porPagina));

  if (total === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-between border-t border-armazon-100 px-6 py-3">
      <span className="text-[11px] uppercase text-armazon-500">
        Mostrando {pagina * porPagina + 1} a {Math.min((pagina + 1) * porPagina, total)} de{' '}
        {total} {quePagina}
      </span>
      <span className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => alCambiar(Math.max(0, pagina - 1))}
          disabled={pagina === 0}
          aria-label="Página anterior"
          className="grid size-8 place-items-center rounded-lg text-armazon-500 transition-colors hover:bg-armazon-100 disabled:opacity-30"
        >
          <ChevronLeft className="size-4" aria-hidden />
        </button>
        <span className="importe px-2 text-xs text-armazon-600">
          {pagina + 1} / {totalPaginas}
        </span>
        <button
          type="button"
          onClick={() => alCambiar(Math.min(totalPaginas - 1, pagina + 1))}
          disabled={pagina >= totalPaginas - 1}
          aria-label="Página siguiente"
          className="grid size-8 place-items-center rounded-lg text-armazon-500 transition-colors hover:bg-armazon-100 disabled:opacity-30"
        >
          <ChevronRight className="size-4" aria-hidden />
        </button>
      </span>
    </div>
  );
}

export const POR_PAGINA = 12;
